import classNames from 'classnames';
import { TableSortDirection, TableHeaderData } from './Table';
import { mdiArrowUpThick as sortAscIcon, mdiArrowDownThick as sortDscIcon } from '@mdi/js';
import Icon from '@components/icon/Icon';
import Tooltip from '@components/tooltip/tooltip';

type Props = TableHeaderData & {
  onClick: (columnName: string, newSortDirection: TableSortDirection, defaultSortDirection: TableSortDirection) => void;
  sortColumn: string;
  sortDirection: TableSortDirection;
};

const TableHeaderCell = ({
  className,
  colSpan,
  defaultSortDirection = 'asc',
  helpText,
  isSortable = true,
  label,
  name,
  onClick,
  rowSpan,
  sortColumn,
  sortDirection,
  width,
}: Props) => {
  const handleClick = () => {
    if (!isSortable) {
      return;
    }
    onClick(name, name === sortColumn && sortDirection === 'asc' ? 'desc' : 'asc', defaultSortDirection);
  };

  const cellStyles = classNames('table-header-cell', className);
  const isSortCol = sortColumn === name;
  const sortIcon = isSortCol ? (sortDirection === 'asc' ? sortAscIcon : sortDscIcon) : null;

  return (
    <th className={cellStyles} colSpan={colSpan} rowSpan={rowSpan} style={{ width: width }}>
      {isSortable ? (
        <button className={`table-sort-btn ${isSortCol ? sortDirection : ''}`} onClick={handleClick} type='button'>
          {label}
          {sortIcon && <Icon focusable={false} path={sortIcon} size='1rem' />}
        </button>
      ) : (
        label
      )}
      {helpText && <Tooltip content={helpText} header={label} />}
    </th>
  );
};

export default TableHeaderCell;
